import React from "react";
import * as Yup from "yup";

import "./index.scss";
import Context from "../../../../../../context";
import { IItem } from "../../../../../../types/common.interface";
import { useFormik } from "formik";
import {
  CustomButton2,
  CustomCheckBox,
  CustomInput,
  CustomModal,
  CustomRadioButtonGroup,
  CustomTimePiker,
  CustomView,
} from "../../../../../../components";
import { OFFLINE_PAYER_WAY } from "../../../../../../values/dropdownItems";
import utils from "../../../../../../utils";
import { useTranslation } from "react-i18next";
import api from "../../../../../../api";
const ExcelJS = require("exceljs"); // Make sure this is installed

const ExportExcel = ({}) => {
  const {
    showModal,
    setShowModal,
    isLoading,
    selectedDebt,
    onPayDebt,
    selectedWithdrawal,
    getAllDebt,
  } = React.useContext(Context.payAdminToDriverContext);
  const [selectedPayerWay, setSelectedPayerWay] = React.useState<IItem>();
  const [date, setDate] = React.useState<string>(new Date().toDateString());
  const [errors, setErrors] = React.useState({ payerType: "", payerWay: "" });
  const [changeStatus, setChangedStatus] = React.useState<boolean>(false);


  const { t } = useTranslation();

  console.log({soheil:getAllDebt?.data?.result?.docs})

  const exportExcelFile = async() => {
    const workBook = new ExcelJS.Workbook({
      useStyle: true,
    }); // Capitalized Workbook correctly
    const sheet = workBook.addWorksheet("My Sheet");

    sheet.columns = [
      {
        header: "Destination Iban Number (Variz Be Sheba)",
        key: "shaba",
        width: 20,
      },
      {
        header: "Owner Name (Name e Sahebe Seporde)",
        key: "name",
        width: 20,
      },
      { header: "Transfer Amount (Mablagh)", key: "price", width: 15 },
      { header: "Destination Note (Sharh)", key: "description", width: 15 },
      { header: "pay Id(Shenaseh variz)", key: "payId", width: 15 },
      {
        header:
          "Please do not remove this first row. (Lotfan radife nokhost ra paak nafarmayid.)",
        key: "des",
        width: 15,
      },
    ];

    // Apply custom styles to the header row (first row)
    // sheet.getRow(1).eachCell((cell: any) => {
    //   cell.fill = {
    //     type: "pattern",
    //     pattern: "solid",
    //     fgColor: { argb: "FCA311" },
    //   };
    //   cell.font = { bold: true, color: { argb: "ffffff" } }; // Bold red text
    //   cell.alignment = { horizontal: "center", vertical: "middle" }; // Center text alignment
    // });

    getAllDebt?.data?.result?.docs
      ?.filter((item: any) => selectedWithdrawal.includes(item._id))
      ?.map((item: any, index: number) => {
        const row = sheet.addRow({
          shaba: "IR" + item?.shabaId,
          name: item?.driver?.firstName + " "+item?.driver?.lastName ,
          price: String(item?.amount)+"0",
          description: "واریزی",
          payId: "",
          des: undefined, // TODO :: [ ] => this field have problem to fix it should use undefinded
        });

        // Apply styles for all rows
        // row.eachCell((cell: any) => {
        //   cell.fill = {
        //     type: "pattern",
        //     pattern: "solid",
        //     fgColor: { argb: "e5e5e5" }, // Blue background
        //   };
        //   cell.font = { bold: true, color: { argb: "000000" } }; // Bold white text
        //   cell.alignment = { horizontal: "center", vertical: "middle" }; // Center text alignment
        // });
      });

    workBook.xlsx.writeBuffer().then((data: any) => {
      const blob = new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheet.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const anchor = document.createElement("a");
      anchor.href = url;

      // Specify the desired file name with the extension `.xlsx`
      anchor.download = `exported-file-${new Date().getTime()}.xlsx`; // or `.xls` if needed with another library
      anchor.click();

      window.URL.revokeObjectURL(url);

    });
    if(changeStatus){
      const result = await api.put.administrator.sendToBankManyPayToDriver({withdrawalId:selectedWithdrawal});
      getAllDebt.refetch()
    }
    setShowModal!("NONE")
  };

  // ?? ===========================================================================================================
  // ??                                              JSX Content
  // ?? -----------------------------------------------------------------------------------------------------------

  return (
    <section id="school-approve-modal-container">
      <CustomModal
        onClose={() => setShowModal!("NONE")}
        open={showModal === "EXPORT_EXCEL"}
        maxHeight={"12rem"}
        label={""}

      >
        <form>
          <CustomView.Container className="approve-form-content">
            <>
            <h6 style={{display:"flex" , justifyContent:"center"}}>خروجی اکسل</h6>
              <CustomView.Row className="radio-button-group">
                <CustomView.Column >
                  
                  <CustomCheckBox isChecked={changeStatus} onChecked={()=>setChangedStatus(!changeStatus)} label={`تغییر وضعیت به " ارسال شده به بانک"`} />
                  </CustomView.Column>
              </CustomView.Row>
              <br />
            </>
            <CustomView.Row className="form-row">
              <CustomView.Column
                large={3}
                medium={4}
                small={6}
                className="form-colum"
              >
                <CustomButton2
                  isLoading={isLoading}
                  onClick={() => setShowModal!("NONE")}
                  title={t("cancel")}
                  type="danger"
                />
              </CustomView.Column>
              <CustomView.Column
                large={3}
                medium={4}
                small={6}
                className="form-colum"
              >
                {/* {role === "ADMIN" && <SwitchButtonHandler />} */}
                <CustomButton2
                  isLoading={isLoading}
                  onClick={exportExcelFile}
                  title={t("approve")}
                  type={"primary"}
                />
              </CustomView.Column>
            </CustomView.Row>
          </CustomView.Container>
        </form>
      </CustomModal>
    </section>
  );
};
export default ExportExcel;
